import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { createNote } from 'Store/Notes/Actions';
import { Button, Form } from 'react-bootstrap';

const NoteEditor = ({ conceptId, onClose }) => {
  const dispatch = useDispatch();
  const [content, setContent] = useState('');

  const handleSave = () => {
    console.log("Saving note for conceptId:", conceptId, "with content:", content);

    const trimmedContent = content.trim();
    if (!trimmedContent) {
    alert("Note content cannot be empty.");
    return;
  }
  if (conceptId === undefined || conceptId === null) {
    alert("Cannot save note: missing concept ID.");
    return;
  }
  const noteData = {
    concept: parseInt(conceptId, 10), 
    content: trimmedContent
  };
  dispatch(createNote(noteData));
  setContent('');
  if (onClose) onClose();
  };

  return (
    <div className="ml-3 mr-3 mt-3 mb-3 p-3 section-full-border bg-white">
      <Form>
        <Form.Group className="mb-3">
          <Form.Label><h6>Add a New Note</h6></Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder="Write your note here..."
            style={{ borderRadius: '4px' }}
          />
        </Form.Group>
        
        <div className="d-flex justify-content-end gap-2">
          <Button variant="outline-secondary" onClick={onClose} size="sm">
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSave} size="sm">
            Save Note
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default NoteEditor;